export default __webpack_public_path__ + "static/media/playlistOrange.3a3599d9.png";